import breadcrumb from './breadcrumb.vue'
import breadcrumbItem from './breadcrumbItem.vue'

export default (Vue) => {
  Vue.component(breadcrumb.name, breadcrumb)
  Vue.component(breadcrumbItem.name, breadcrumbItem)
}



// WEBPACK FOOTER //
// ./src/components/commonBreadcrumb/index.js